import AbstractNodeView from './AbstractNodeView';
import NodeViewConstructorArgs from '../constructor/NodeViewConstructorArgs';
import * as d3 from 'd3';
import View from '../view/View';
import { Syntax } from '@trlogic/ui-pack';
import { NodeType } from '../../../../domain/collection/rule/FlowDomains';
import link from '../assets/link.svg';
import linkOff from '../assets/link_off.svg';

class TransitionView extends AbstractNodeView {
  private d: any;

  public constructor(args: NodeViewConstructorArgs) {
    super(args);
  }

  public initialize(): void {}

  public render(d: any): void {
    this.d = d;
    d3.select('#workflow-container-group')
      .insert('path', 'g')
      .attr('id', (d: any) => {
        return this.getNode();
      })
      .attr('x', 50 / 2)
      .attr('y', 50 / 2)
      .attr('class', 'link')
      .attr('d', () => {
        return this.diagonal(d, d.parent);
      });

    if (d.data.value.type == 'NotFraud') {
      /*
      d3.select("#workflow-container-group")
        .append("rect")
        .attr("x", (d.x + d.x) / 2 + 60 / 2 - 50)
        .attr("y", (d.y + d.y) / 2 + 100 / 2 - 90)
        .attr("width", 40)
        .attr("height", 20)
        .style("fill", "#FBFBFB");

      d3.select("#workflow-container-group")
        .append("text")
        .style("fill", "#bdbdbd")
        .attr("x", 50 / 2 + 40)
        .attr("y", 50 / 2 - 2)
        .attr("dy", ".35em")
        .attr("x", (d.x + d.x) / 2 + 60 / 2 - 40)
        .attr("y", (d.y + d.y) / 2 + 100 / 2 - 80)
        .text("Yes")
       */
    }
    if (d.data.value.type == 'Fraud') {
      d3.select('#workflow-container-group')
        .append('rect')
        .attr('x', (d.x + d.x) / 2 + 60 / 2 - 160)
        .attr('y', (d.y + d.y) / 2 + 100 / 2 - 120)
        .attr('width', 36)
        .attr('height', 20)
        .style('fill', '#FBFBFB');
      d3.select('#workflow-container-group')
        .append('svg:image')
        .attr('xlink:href', (this.getModel().value as any).status ? link : linkOff)
        .attr('width', 20)
        .attr('height', 20)
        .attr('x', (d.x + d.x) / 2 + 60 / 2 - 150)
        .attr('y', (d.y + d.y) / 2 + 100 / 2 - 120)
        .style('cursor', 'pointer')
        .on('click', () => {
          if ((this.getModel().parent as any).value.status) {
            this.workFlowView.changeCaseStatus();
          }
        });

      d3.select('#workflow-container-group')
        .append('rect')
        .attr('x', (d.x + d.x) / 2 + 60 / 2 - 45)
        .attr('y', (d.y + d.y) / 2 + 100 / 2 - 90)
        .attr('width', 36)
        .attr('height', 20)
        .style('fill', '#FBFBFB');

      d3.select('#workflow-container-group')
        .append('text')
        .style('fill', '#bdbdbd')
        .attr('x', 50 / 2)
        .attr('y', 50 / 2)
        .attr('dy', '.35em')
        .attr('x', (d.x + d.x) / 2 + 60 / 2 - 38)
        .attr('y', (d.y + d.y) / 2 + 100 / 2 - 80)
        .text('No');
    }
  }

  private renderSocket(d: any): void {
    if (d.data.value.type == 'Action') {
      /*
      d3.select("#workflow-container-group")
        .append("svg:image")
        .attr("xlink:href", socket)
        .attr("id", this.el.substring(1, this.el.length))
        .attr("width", 30)
        .attr("height", 30)
        .attr("x", (d.x + d.x) / 2 + 60 / 2 - 45)
        .attr("y", (d.y + d.y) / 2 + 100 / 2 - 100)
        .attr("alignment-baseline", "middle")
        .attr("text-anchor", "middle")
       */
    }
  }

  private diagonal = (s: any, d: any) => {
    return `M ${s.x} ${s.y}
            L ${s.x} ${(s.y + d.y) / 2}
            L ${d.x} ${(s.y + d.y) / 2}
            L ${d.x} ${d.y}`;
  };

  public socketHighlight(type?: NodeType): void {
    this.renderSocket(this.d);
  }

  public socketUnHighlight(): void {}

  protected preSwap(target: View<Syntax>): boolean {
    return false;
  }

  public setModel(model: Syntax) {}
}

export default TransitionView;
